module.exports = "/_next/static/images/slide-1-75115bcc3b63224db4e9ca0ab3a7781e.jpeg";